import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { DeliveryService, DeliveryUpdateDto } from 'src/generated_client';

@Component({
  selector: 'app-edit-person',
  templateUrl: './edit-person.component.html',
  styleUrls: ['./edit-person.component.css']
})
export class EditPersonComponent implements OnInit {

  id: any;
  updateDelivery: DeliveryUpdateDto = {} as DeliveryUpdateDto;

  options = [
    { value: true, viewValue: 'Activo' },
    { value: false, viewValue: 'Desactivado' },
  ];

  editPersonForm: FormGroup = this.fb.group({
    nombre: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    comision: ['', Validators.compose([Validators.required,Validators.min(1)])],
    tel: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    estado: ['', Validators.required],
    patente: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    tarjetaC: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    vencT: ['', Validators.required],
    licencia: ['',  Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    vencL: ['', Validators.required],
    newPassword: ['']
  })

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public deliveryService: DeliveryService,
    private router: Router,
    private snackBar: SnackBarService
  ) {
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get("id");
    this.deliveryService.apiDeliveryGetOneGet(this.id).subscribe(d => {
      this.editPersonForm.controls['nombre'].setValue(d.dsName);
      this.editPersonForm.controls['comision'].setValue(d.qtCommission);
      this.editPersonForm.controls['tel'].setValue(d.dsPhone);
      this.editPersonForm.controls['estado'].setValue(d.isActive);
      this.editPersonForm.controls['patente'].setValue(d.dsPatent);
      this.editPersonForm.controls['tarjetaC'].setValue(d.dsCirculation);
      this.editPersonForm.controls['vencT'].setValue(d.dtCirculationExpiration);
      this.editPersonForm.controls['licencia'].setValue(d.dsLicense);
      this.editPersonForm.controls['vencL'].setValue(d.dtLicenseExpiration);
    })
  }

  saveChanges(form: any) {
    this.updateDelivery = {
      cdDelivery: Number(this.id),
      dsName: form.nombre,
      dsPhone: form.tel,
      dsNewPassword: form.newPassword,
      isActive: form.estado,
      dtLicenseExpiration: form.vencL,
      dtCirculationExpiration: form.vencT,
      dsLicense: form.licencia,
      dsCirculation: form.tarjetaC,
      dsPatent: form.patente,
      qtCommission: form.comision
    }
    this.deliveryService.apiDeliveryEditPut(this.updateDelivery).subscribe(response => {
      this.router.navigate(['personal']);
      this.snackBar.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
    }, (err) => {
      this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
    });
  }

}
